export const LIFECYCLE_ANALYTICS_EVENTS = {
  DEAL_CREATED: 'deal_created',
  PACKAGE_CREATED: 'package_created',
  USER_LOGGED_IN: 'user_logged_in',
} as const;

const PORTAL_LOGIN_PERSISTED_SESSION_KEY = 'posthog_portal_login_persisted';
const PORTAL_LOGIN_TRACKED_SESSION_KEY = 'posthog_login_tracked';

export const MAX_LOGIN_SYNC_RETRIES = 30;

export function portalLoginPersistedSessionKey(userId: string): string {
  return `${PORTAL_LOGIN_PERSISTED_SESSION_KEY}:${userId}`;
}

export function portalLoginTrackedSessionKey(userId: string): string {
  return `${PORTAL_LOGIN_TRACKED_SESSION_KEY}:${userId}`;
}

/** Clears per-user portal-login session guards. Pass userId when known. */
export function clearPortalLoginSessionKeys(userId?: string): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }

  try {
    if (userId) {
      sessionStorage.removeItem(portalLoginPersistedSessionKey(userId));
      sessionStorage.removeItem(portalLoginTrackedSessionKey(userId));
    }

    // Drop legacy global keys and any orphaned per-user entries.
    const legacyKeys = [
      PORTAL_LOGIN_PERSISTED_SESSION_KEY,
      PORTAL_LOGIN_TRACKED_SESSION_KEY,
    ];
    for (let index = sessionStorage.length - 1; index >= 0; index -= 1) {
      const key = sessionStorage.key(index);
      if (!key) {
        continue;
      }
      if (
        legacyKeys.includes(key) ||
        legacyKeys.some(prefix => key.startsWith(`${prefix}:`))
      ) {
        sessionStorage.removeItem(key);
      }
    }
  } catch {
    // Storage may be unavailable (private mode, SecurityError) — never block sign-out.
  }
}
